import { useState } from "react";
import "../../Styles/exportToFigma.scss";
import { hexToHSL } from "../Colorize/ColorUtils";
import { CloseButton } from "../ReusableComponents/PopupDefault";
import { usePopupQueue } from '../ReusableComponents/usePopupQueue';

const ExportToFigma = ({ onClose, palette, colorName, selectedIndex, squareNames }) => {
  const { activePopups, addPopup } = usePopupQueue();
  const [isCopied, setIsCopied] = useState(false);

  // Format color name for groupName
  const colorNameFormatted = colorName.trim();

  const baseShade = selectedIndex !== null && selectedIndex !== undefined
    ? squareNames[selectedIndex]
    : "600";

  // Convert color to HSL object with h, s, l properties
  const formatHSLObject = (color) => {
    try {
      // Check if already HSL format
      if (typeof color === 'string' && color.startsWith('hsl(')) {
        // Parse the HSL string
        const hslMatch = color.match(/hsl\(\s*(\d+\.?\d*)\s*,\s*(\d+\.?\d*)\s*%\s*,\s*(\d+\.?\d*)\s*%\s*\)/);

        if (hslMatch) {
          const h = parseFloat(hslMatch[1]);
          const s = parseFloat(hslMatch[2]);
          const l = parseFloat(hslMatch[3]);

          return {
            h: Math.round(h),
            s: Math.round(s),
            l: Math.round(l)
          };
        }
      }

      // Convert hex to HSL
      const { h, s, l } = hexToHSL(color);
      return {
        h: Math.round(h * 360),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
      };
    } catch (e) {
      console.error('Invalid color value for HSL conversion:', color, e);
      return { h: 0, s: 0, l: 0 };
    }
  };

  // Generate the JSON output
  const generateFigmaJSON = () => {
    const output = {
      groupName: colorNameFormatted,
      baseShade: baseShade,
      variables: {
        "50": { hsl: formatHSLObject(palette[0]) },
        "100": { hsl: formatHSLObject(palette[1]) },
        "200": { hsl: formatHSLObject(palette[2]) },
        "300": { hsl: formatHSLObject(palette[3]) },
        "400": { hsl: formatHSLObject(palette[4]) },
        "500": { hsl: formatHSLObject(palette[5]) },
        "600": { hsl: formatHSLObject(palette[6]) },
        "700": { hsl: formatHSLObject(palette[7]) },
        "800": { hsl: formatHSLObject(palette[8]) },
        "900": { hsl: formatHSLObject(palette[9]) },
        "950": { hsl: formatHSLObject(palette[10]) }
      }
    };

    return JSON.stringify(output, null, 2);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(generateFigmaJSON());
    addPopup('Copied JSON data');

    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <div className="export-to-figma-popup">


      <div className="intro">
        <h4>Export to Figma</h4>
        <p>Copy and paste the JSON into the <a href="https://www.figma.com/community/plugin/1544422242387734389" target="_blank" rel="noopener noreferrer">No61 Figma plugin</a> to create your color variables.</p>
      </div>

      <div className="code-block-wrap">
        <pre className="code-block">{generateFigmaJSON()}</pre>
      </div>
      


      <button
        className={`copy-btn svg---text pri-btn ${isCopied ? 'copied' : ''}`}
        onClick={handleCopy}
      >
        <svg className="copy-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
          <path d="M3.7 12.7H2.8C2.32261 12.7 1.86477 12.5104 1.52721 12.1728C1.18964 11.8352 1 11.3774 1 10.9V2.8C1 2.32261 1.18964 1.86477 1.52721 1.52721C1.86477 1.18964 2.32261 1 2.8 1H10.9C11.3774 1 11.8352 1.18964 12.1728 1.52721C12.5104 1.86477 12.7 2.32261 12.7 2.8V3.7M9.1 7.3H17.2C18.1941 7.3 19 8.10589 19 9.1V17.2C19 18.1941 18.1941 19 17.2 19H9.1C8.10589 19 7.3 18.1941 7.3 17.2V9.1C7.3 8.10589 8.10589 7.3 9.1 7.3Z" stroke="#ffffff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <svg className="checkmark-icon" width={18} height={18} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#ffffff">
          <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
        </svg>
        <span>{isCopied ? 'Copied' : 'Copy JSON'}</span>
      </button>







      <CloseButton onClose={onClose} />

      {/* popup */}
      {activePopups.length > 0 && (
        <div className="popup-timed-container centered">
          {activePopups.map((popup) => (
            <div key={popup.id} className="popup-timed">
              <div className="popup-timed-content">
                <div className="svg---text">
                  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                  <p>{popup.message}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExportToFigma;